export default __webpack_public_path__ + "static/cert-icon-08-0a17f028223e8adbcbb1eaae7e0635c5.png";